const productConfig = [
  {
    isShow: true,
    productId: 'xpoker-diamond1k',
    diamond: '1k',
    price: '$8',
    extra: ''
  },
  {
    isShow: true,
    productId: 'xpoker-diamond2k',
    diamond: '2k',
    price: '$16',
    extra: ''
  },
  {
    isShow: true,
    productId: 'xpoker-diamond3k',
    diamond: '3k',
    price: '$23',
    extra: ''
  },
  {
    isShow: true,
    productId: 'xpoker-diamond10k',
    diamond: '10k',
    price: '$73',
    extra: ''
  },
  {
    isShow: true,
    productId: 'xpoker-diamond20k',
    diamond: '20k',
    price: '$145',
    extra: ''
  },
  {
    isShow: true,
    productId: 'xpoker-diamond50k',
    diamond: '50k',
    price: '$359',
    extra: ''
  },
  {
    isShow: true,
    productId: 'xpoker-diamond100k',
    diamond: '100k',
    price: '$709',
    extra: ''
  },
  {
    isShow: true,
    productId: 'xpoker-diamond200k',
    diamond: '200k',
    price: '$1418',
    extra: ''
  },
  {
    isShow: true,
    productId: 'xpoker-diamond500k',
    diamond: '500k',
    price: '$3499',
    extra: ''
  }
]

export default productConfig



// WEBPACK FOOTER //
// ./src/util/product.js